import { Icon, Badge } from '@aliza/ui';

export interface NotificationBellProps {
  count: number;
  onClick?: () => void;
}

export function NotificationBell({ count, onClick }: NotificationBellProps) {
  return (
    <button
      data-testid="notification-bell"
      onClick={onClick}
      aria-label={`Notifications${count > 0 ? ` (${count} unread)` : ''}`}
      style={{ position: 'relative', background: 'none', border: 'none', cursor: 'pointer', padding: 8 }}
    >
      <Icon name="bell" size={24} />
      {count > 0 && (
        <span
          data-testid="bell-badge"
          style={{ position: 'absolute', top: 2, right: 2 }}
        >
          <Badge variant="count" color="error">{count}</Badge>
        </span>
      )}
    </button>
  );
}
